// Modals.css is no longer used here, but this is the only file that loads it and other
// (not yet migrated) modals still rely on its global .modal-btn-group/.spas-title/.save-buttons.
import "./Modals.css";
import React, {useState, useEffect} from "react";
import { deregisterSpaUser, editSpa, fetchSpa, registerSpaUser } from "../../../redux/actions/spa.actions";
import { AppDispatch } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/states/root.state";
import UserSelect from "../UserSelect/UserSelect";
import DealershipSelect from "../UserSelect/DealershipSelect";
import { ModalProps } from "../Interfaces/Modals";
import usePermissionCheck from "../../../hooks/usePermissionCheck";
import ModalShell, { ModalLoading } from "./ModalShell";

const EditSpaModal: React.FC<ModalProps> = ({open, setOpen, object_id}) => {
    const id = object_id;
    
    const dispatch: AppDispatch = useDispatch();
    const [updateInfo, setUpdateInfo] = useState<any>(null);
    const [selectedUser, setSelectedUser] = useState<any>(null);
    const [selectedDealership, setSelectedDealership] = useState<any>(null);

    const {canAccess:canEditUser} = usePermissionCheck(['register_to_user','deregister_from_user']);

    const {data:spa, loading, error} = useSelector((state: RootState)=>state.spa)

    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        if (id && open){
            dispatch(fetchSpa(id));
        }
    }, [id,open, dispatch]);

    useEffect(() => {
        if (spa?.user) {
            setSelectedUser(spa.user);
        }
    }, [spa]);

    useEffect(() => {
        if (selectedDealership){
            setUpdateInfo({...updateInfo,dealership_id:selectedDealership.id});
        }
    }, [selectedDealership]);

    const handleClose = () => {
        setUpdateInfo(null);
        setSelectedUser(null);
        setSubmitted(false);
        setOpen(false);
        setSelectedDealership(null);
    };

    /* Handle text input */
    const handleInput = (e: any) => {
        let input = e.target.value;
        setUpdateInfo({...updateInfo,nick_name:input})
    };

    const handleEdit = async () => {
        setSubmitted(true);
        if (updateInfo){
            await dispatch(editSpa({...updateInfo,guid:spa?.id}));
        }

        if(selectedUser && !error){
            if (selectedUser!=='none'){
                await dispatch(registerSpaUser({guid:spa?.id, user_id:selectedUser.id}));
            } else {
                await dispatch(deregisterSpaUser({guid:spa?.id, user_id:selectedUser.id}));
            } 
        }
    }

  const busy = Boolean(loading) && submitted && !error;
  const done = Boolean(error) || submitted;

  return (
    <ModalShell
      open={open}
      onClose={handleClose}
      size={done ? "sm" : "md"}
      busy={busy}
      tone={error ? "error" : busy ? undefined : submitted ? "success" : undefined}
      title={
        error ? "An error occurred"
        : busy ? "Updating…"
        : loading ? "Loading…"
        : submitted ? "Spa updated"
        : <>Edit spa <strong>{spa?.nick_name}</strong></>
      }
      actions={busy ? undefined : done ?
        <button className="btn btn-primary" onClick={handleClose}>OK</button>
        :
        <>
          <button className="btn" onClick={handleClose}>Cancel</button>
          <button className="btn btn-primary" onClick={handleEdit} disabled={loading || (!updateInfo && !selectedUser)}>Confirm</button>
        </>
      }
    >
      {error ?
        <p>{error}</p>
      : loading ?
        <ModalLoading/>
      : submitted ?
        <p>Spa successfully updated.</p>
      :
        <>
          <div className="field">
            <label className="field-label" htmlFor="nick-name-input">Nickname</label>
            <input type="text" id="nick-name-input" className="input" placeholder="Enter new nickname" defaultValue={spa?.nick_name} onChange={handleInput}/>
          </div>

          {canEditUser && <>
            <div className="dlg-section">
              <div className="dlg-current">
                <span className="dlg-label">Current user</span>
                <strong>{spa?.user ? spa?.user?.name : `None`}</strong>
              </div>
              <UserSelect setSelectedUser={setSelectedUser} currentUser={selectedUser || spa?.user}/>
            </div>

            <div className="dlg-section">
              <div className="dlg-current">
                <span className="dlg-label">Current dealership</span>
                <strong>{spa?.dealership ? spa?.dealership.name : `None`}</strong>
              </div>
              <DealershipSelect setSelected={setSelectedDealership} selected={selectedDealership} current={spa?.dealership} />
              {selectedDealership && (
                <p><strong>Will be assigned to:</strong> {selectedDealership.name} (ID: {selectedDealership.id})</p>
              )}
            </div>
          </>}
        </>
      }
    </ModalShell>
  );
};

export default EditSpaModal;
